import { styled } from '@mui/material/styles';
import { Global, css } from '@emotion/react';

export const AppLogo = styled('div')(() => ({
    display: 'inline-block',
    maxWidth: '190px',
    '@media print': {
        maxWidth: '50px',
    }
}));

export const AppLogoImg = styled('img')(() => ({
    maxWidth: '100%'
}));

export const DescriptionBox = styled('div')(() => ({
    marginBottom: '30px',
    '@media print': {
        display: 'none'
    }
}));

export const GlobalPrintStyles = () => (
    <Global
        styles={css`
            @media print {
                /* Page-level margins: Basic 0.5cm on all sides for edge breathing room */
                @page {
                    size: A4 portrait;
                    margin: 0.5cm;
                }

                /* Reset global margins/padding, but add left/right for readability */
                body,
                html,
                #root {
                    margin: 0.5cm 0.5cm 0 !important;
                    padding: 0 !important;
                    height: auto !important;
                    width: calc(100% - 1cm) !important;
                }

                /* Target MUI Container and main elements */
                .MuiContainer-root,
                main,
                .main {
                    margin: 0 !important;
                    padding: 0 !important;
                    max-width: none !important;
                    width: 100% !important;
                    box-sizing: border-box;
                }

                /* Target MUI Box and wrappers */
                .MuiBox-root,
                .ReviewWrapper {
                    margin: 0 !important;
                    padding: 5px 0 !important;
                }

                /* Base font reduction: 10px for all text (titles inherit but can be overridden) */
                body {
                    font-size: 10px !important;
                    line-height: 1.1 !important;
                    font-family: 'Roboto', sans-serif !important;
                }

                /* Specific overrides for headings (keep slightly larger) */
                .MuiTypography-h1,
                .MainTitle {
                    font-size: 12px !important;
                    margin: 0 0 8px 0 !important;
                    line-height: 1.2 !important;
                }

                /* Hide buttons and non-essential UI */
                .MuiButton-root,
                .ButtonGroup,
                button,
                footer,
                header {          /* Target your footer's class */
                    display: none !important;
                }
                
                /* Handle signatures/images if present in ReviewData */
                img[alt*="Signature"],
                .Signature {
                    max-width: 40% !important;
                    height: auto !important;
                    margin: 2px 0 !important;
                }
            }
        `}
    />
);
